import { Component,  Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TagData } from 'globals/store/tags.data';
import { sortByProp } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { PhotoComponent } from 'src/app/components/photo';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';

@Component({
    selector: 'tags',
    template: `
<add-manage-wrapper 
  [hideHRule]="true" 
  [titleIcon]="noTitle ? null : titleIcon"
  [wrapperTitle]="noTitle ? '' : title" 
  [openLabel]="readOnly ? '' : tagText" 
  (open)="open.emit($event)"
>
  <div class="tags" *ngIf="!!usedTags?.length">
    <div class="tag-holder" *ngFor="let tag of usedTags; trackBy: trackById" >
      <photo *ngIf="showPhoto" [data]="tag"></photo>
      <div class="name">{{ tag.title }}</div>
      <icon *ngIf="!readOnly" class="close" [icon]="'close'" (click)="remove.emit(tag.id)"></icon>
    </div>
  </div>
  <div class="empty-text" *ngIf="!usedTags?.length">{{ emptyText }}</div>
</add-manage-wrapper>

`,
    styleUrls: ['./tags.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, PhotoComponent, AddManageWrapperComponent]
})
export class TagsComponent implements OnChanges {
  @Input() titleIcon: string
  @Input() title: string
  @Input() tagText: string
  @Input() showPhoto: boolean = false // this is necessary to show initials if no photo present
  @Input() tags: TagData[]
  @Input() emptyText: string
  @Input() readOnly = true
  @Input() noTitle = false
  usedTags: TagData[]

  @Output() remove: EventEmitter<string> = new EventEmitter()
  @Output() open: EventEmitter<any> = new EventEmitter()

  ngOnChanges() {
    if (this.tags) this.usedTags = this.tags.sort(sortByProp('title'))
  }
  
  trackById(_, tag: TagData) {
    return tag.id
  }
}

